const ACTION_TYPES = {
    SET_RWD_BASKET: 'SET_RWD_BASKET'
};

const initialState = {
    isInitialized: false
};

const reducer = function (state = initialState, action) {
    switch (action.type) {
        case ACTION_TYPES.SET_RWD_BASKET: {
            const newState = { isInitialized: true };

            return newState;
        }
        default:
            return state;
    }
};

reducer.ACTION_TYPES = ACTION_TYPES;

module.exports = reducer;
